import axios from "axios";
import {
  KOMISI_ALL_CABANG_GET_FAIL,
  KOMISI_ALL_CABANG_GET_REQUEST,
  KOMISI_ALL_CABANG_GET_RESET,
  KOMISI_ALL_CABANG_GET_SUCCESS,
} from "../constants/KomisiAllCabangConstants";
import {
  API_KOMISI_ALL_CABANG_GET,
  API_KOMISI_ALL_CABANG_GET_DOWNLOAD,
} from "../init/api_url";
import { Logout } from "../../loginModul/actions/loginAction";
import { ActGeneralButtonDownloadSuccess } from "../../../general/components/button/ButtonDownloadsrc/action";

export const DownloadGetKomisiAllCabang =
  ({ dateStart, dateEnd }) =>
  async (dispatch, getState) => {
    let fileName = "Komisi Semua Cabang.xlsx";
    const {
      userLogin: { token },
    } = getState();
    const data = await axios({
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: API_KOMISI_ALL_CABANG_GET_DOWNLOAD,
      method: "GET",
      responseType: "blob", // important
      params: {
        startDate: dateStart,
        endDate: dateEnd,
      },
    });
    console.log("Download Data", data["Content-Disposition"], data);
    const url = window.URL.createObjectURL(new Blob([data.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    dispatch(ActGeneralButtonDownloadSuccess());
  };

export const GetKomisiAllCabang =
  ({ dateStart, dateEnd }) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: KOMISI_ALL_CABANG_GET_REQUEST,
      });
      const {
        userLogin: { token },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          startDate: dateStart,
          endDate: dateEnd,
        },
      };
      const { data: data } = await axios.get(API_KOMISI_ALL_CABANG_GET, config);
      console.log("testing Action get Komisi all cabang", data);
      dispatch({
        type: KOMISI_ALL_CABANG_GET_SUCCESS,
        payload: data,
      });
    } catch (error) {
      if (error.response.status == 401) {
        dispatch(Logout());
      }
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      dispatch({
        type: KOMISI_ALL_CABANG_GET_FAIL,
        payload: message,
      });
    }
  };

export const RGetKomisiAllCabang = () => async (dispatch, getState) => {
  dispatch({
    type: KOMISI_ALL_CABANG_GET_RESET,
  });
};
